import { useState, useEffect, useCallback } from 'react';
import { UI_SETTINGS } from '../constants/search';

interface UseResponsiveViewReturn {
  isMobile: boolean;
  showMobileFilters: boolean;
  toggleMobileFilters: () => void;
  closeMobileFilters: () => void;
}

export const useResponsiveView = (): UseResponsiveViewReturn => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < UI_SETTINGS.MOBILE_BREAKPOINT
  );
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < UI_SETTINGS.MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) {
        setShowMobileFilters(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle body scroll lock for mobile filters
  useEffect(() => {
    if (showMobileFilters && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showMobileFilters, isMobile]);

  const toggleMobileFilters = useCallback(() => {
    setShowMobileFilters(prev => !prev);
  }, []);

  const closeMobileFilters = useCallback(() => {
    setShowMobileFilters(false);
  }, []);

  return {
    isMobile,
    showMobileFilters,
    toggleMobileFilters,
    closeMobileFilters
  };
}; 